var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-bar"},[_c('div',{staticClass:"progress",style:({ width: _vm.value + '%' })}),_c('img',{staticClass:"progress-logo",style:({ left: _vm.value + '%' }),attrs:{"src":require("@/assets/style/progress-logo.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }